import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';
const [
    LIST_PURCHASE_QUOTE_FILES,
    LIST_PURCHASE_QUOTE_FILES_SUCCESS,
    LIST_PURCHASE_QUOTE_FILES_FAILURE,
] = createRequestActionTypes('chance/LIST_PURCHASE_QUOTE_FILES');
export const listPurchaseQuoteFiles = createAction(
    LIST_PURCHASE_QUOTE_FILES,
    (fileTyp, fileAttrVal1, fileAttrVal3) => ({ fileTyp, fileAttrVal1, fileAttrVal3 }),
);
const listPurchaseQuoteFilesSaga = createRequestSaga(
    LIST_PURCHASE_QUOTE_FILES,
    chanceApi.getPurchaseQuoteFiles,
);


export function* purchaseQuoteFilesSaga() {
    yield takeLatest(LIST_PURCHASE_QUOTE_FILES, listPurchaseQuoteFilesSaga);
}

const initialState = {
    files: null,
    error: null,
};

const purchaseQuoteFiles = handleActions(
    {

        [LIST_PURCHASE_QUOTE_FILES_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            files: data.list.map((file) => ({
                id: file.fileUuid,
                fileUrl: file.fileUrl,
                fileTyp: file.fileTyp,
                fileAttrVal1: file.fileAttrVal1, //prjUuid
                fileAttrVal2: file.fileAttrVal2,
                fileAttrVal3: file.fileAttrVal3,
                fileNm: file.fileNm,
                fileDesc: file.fileDesc,
                crtNm: file.crtNm,
                crtDt: file.crtDt,
                cngNm: file.cngNm,
                cngDt: file.cngDt,
            })),
            error: null,
        }),
        [LIST_PURCHASE_QUOTE_FILES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
    },
    initialState,
);

export default purchaseQuoteFiles;


